import { FaqAccordion } from './faq_accordion';
import { Player } from '../player';
import { constants } from '../../helpers/constants';

const Participate = () => {
  return (
    <>
      {/* <!-- Video / FAQ --> */}
      <section className='bg-light-base py-24 dark:bg-jacarta-800'>
        <div className='container'>
          <div className='mx-auto mb-12 max-w-xl text-center'>
            <h2 className='mb-6 text-center font-display text-3xl font-medium text-jacarta-700 dark:text-white'>
              How to Participate
            </h2>
            <p className='text-lg dark:text-jacarta-300'>
              By listing your collection on this platform where there are many NFT users, you can
              make your collection stand out.
            </p>
          </div>
          <div className='flex flex-col gap-6 lg:flex-row'>
            <div className='lg:w-[59%]'>
              {/* <VideoBlock /> */}
              <Player url={`${constants?.cdn?.path}videos/Bit5_video.mp4`} />
            </div>
            {/* End VideoBlock */}

            <div className='lg:w-[41%]'>
              {/* <p className='mb-6 dark:text-jacarta-300'>
                DAOs are said to be the future of work. As a concept and a technology, DAO can
                transform the structure of a legacy business by empowering member-owned communities
                and removing centralized leadership.
              </p>
              <a href='#' className='mb-8 inline-block text-sm font-bold text-accent'>
                Learn More
              </a> */}
              <FaqAccordion faqs={faqs} />
            </div>
            {/* End Faq */}
          </div>
        </div>
      </section>
      {/* <!-- end video / faq -->   */}
    </>
  );
};

const faqs = [
  {
    id: 1,
    question: 'How to list a collection on Bit5?',
    answer:
      'To list your own Collection at Bit5, firstly, we want you to fill and send a Collection Application Form. You can access to form by clicking <a class="text-accent" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSes0HEtUQMkDfVWmgnYIOP5Kr4gqCW8fURiRdYVcgJ8BaFkvw/viewform" rel="noreferrer">here.</a>',
  },
  {
    id: 2,
    question: 'How to verify a collection?',
    answer:
      'To receive a verification badge for your collection, you need to fill out a form. You can access the form by clicking <a class="text-accent" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfbH82AaYUXSj8tSpVzzUAiWAMpksAp6HmVdiD2LXuuN1UXug/viewform" rel="noreferrer">here.</a>',
  },
  {
    id: 3,
    question: 'How to mint a collection?',
    answer:
      'To mint your NFTs on Bit5, apply through the Minting Application Form. You can access to form by clicking <a class="text-accent" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSfb0LK0nVypb1i1knzI8E_I_oqNEnb-mHwnxW-pfukvZZXfwg/viewform" rel="noreferrer">here.</a>',
  },
  {
    id: 4,
    question: 'How does Bit5 distribute fees?',
    answer:
      'There are two ways of distributing fees in Bit5. One way is Payment Splitter and the other one is EIP-2981. Bit5 charges a 2% fee on items sold. For a limited time, our fees will be 0% so that you can enjoy the lowest fees on BNBChain. You can find much more information about this by clicking <a class="text-accent" target="_blank" href="https://docs.bit5.com/product-guides/marketplace/royalties" rel="noreferrer">here.</a>',
  },
  {
    id: 5,
    question: 'How does Bit5 calculate NFT rarity?',
    answer:
      'Bit5 uses the Rarity Score method, which is used by rarity.tools. You can find details about this calculation by clicking <a class="text-accent" target="_blank" href="https://docs.bit5.com/product-guides/marketplace/nft-rarity-calculation" rel="noreferrer">here.</a>',
  },
];

export default Participate;
